var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.838,
    height: 18.973,
    viewBox: "0 0 21.838 18.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(0 -8.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_239",
    "data-name": "Gruppe 239",
    transform: "translate(0 8.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_238",
    "data-name": "Gruppe 238",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5620",
    "data-name": "Pfad 5620",
    d: "M.682,89.1a.682.682,0,0,1,.682.682v3.412A1.365,1.365,0,0,0,2.73,94.56H19.108a1.365,1.365,0,0,0,1.365-1.365V89.782a.682.682,0,0,1,1.365,0v3.412a2.73,2.73,0,0,1-2.73,2.73H2.73A2.73,2.73,0,0,1,0,93.195V89.782A.682.682,0,0,1,.682,89.1Z",
    transform: "translate(0 -76.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5621",
    "data-name": "Pfad 5621",
    d: "M44.789,9.192a.682.682,0,0,1,.966,0l4.095,4.095a.683.683,0,1,1-.966.966l-2.929-2.93v12a.682.682,0,1,1-1.365,0v-12l-2.929,2.93a.683.683,0,0,1-.966-.966Z",
    transform: "translate(56.191 24.007) rotate(180)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.0794215861c8d77d492a3284948ee3ed.svg";
export { ForwardRef as ReactComponent };